import { render, staticRenderFns } from "./urunler.vue?vue&type=template&id=4cd72f7a&scoped=true&"
import script from "./urunler.vue?vue&type=script&lang=js&"
export * from "./urunler.vue?vue&type=script&lang=js&"
import style0 from "./urunler.vue?vue&type=style&index=0&id=4cd72f7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd72f7a",
  null
  
)

export default component.exports